import { type FC } from 'react';
import { AppShell, Box, Group, Text } from '@mantine/core';
import { Link } from 'react-router';
import { useUnit } from 'effector-react';
import { IconWorld } from '@tabler/icons-react';
import { ModeSwitcher } from '~/features/ModeSwitcher';
import { $authInfo } from '~/entities/auth';
import { routes } from '~/shared/constants/routes';
import { useBreakpoint } from '~/shared/lib/hooks/useBreakpoint';
import { ThemeSwitcher } from '~/shared/ui/ThemeSwitcher';
import { ProfileMenu, TicketCenter } from './components';
import styles from './header.module.css';

const headerHeight = 'var(--header-height)';

export const Header: FC = () => {
    const authInfo = useUnit($authInfo);
    const isMobile = useBreakpoint('mobile');

    const { isAuthenticated } = authInfo;

    return (
        <AppShell.Header h={headerHeight}>
            <Box className={styles.header}>
                <Link
                    className={styles.brand}
                    to={routes.app}
                >
                    <Group
                        align='center'
                        gap={4}
                        wrap='nowrap'
                    >
                        <IconWorld />

                        <Group
                            gap={0}
                            align='start'
                            wrap='nowrap'
                        >
                            <Text
                                size='24px'
                                fw={700}
                                c='brand'
                            >
                                Unite
                            </Text>

                            <Text
                                fz={13}
                                fs='italic'
                                c='brand'
                                mt={-8}
                                ml={-2}
                                ff='monoscape'
                            >
                                admin
                            </Text>
                        </Group>
                    </Group>
                </Link>

                <Box className={styles.mode}>
                    <ModeSwitcher />
                </Box>

                {isAuthenticated && (
                    <Group
                        className={styles.actions}
                        gap='sm'
                        wrap='nowrap'
                    >
                        <ThemeSwitcher />

                        <TicketCenter />

                        {!isMobile && <ProfileMenu />}
                    </Group>
                )}
            </Box>
        </AppShell.Header>
    );
};
